module.exports = __webpack_public_path__ + "img/logo.013c5193.png";